module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVQAAABQCAYAAABGdI0XAAABL0lEQVR4nO3UMQGAQADEsANLuEEnAhHxHRMJHXrt/Z4BcOyWEKBhqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgIihAkQMFSBiqAARQwWIGCpAxFABIoYKEDFUgMK2HwMoAeFTITgCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/quadrilateral.png
// module id = R0Mr
// module chunks = 3